import { render, staticRenderFns } from "./TheBreadcrumb.vue?vue&type=template&id=1e35976a&scoped=true&"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./TheBreadcrumb.vue?vue&type=style&index=0&id=1e35976a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e35976a",
  null
  
)

export default component.exports